<template lang="html">
  <div class="">

  <v-dialog v-model="intDialogVisible" max-width="60%" class="addValueModal addComment" scrollable attach="body">
    <v-card>

        <div class="toptophead">
          <span class="title" v-if="result._id == null">{{$t("Confirm your interest level")}}</span>
            <span class="title" v-else>{{$t("Next step")}}</span>
          <div class="close" @click="close">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.85219 2.15L7.80219 7.1L12.7522 2.15C12.9522 1.95 13.2622 1.95 13.4622 2.15C13.6622 2.35 13.6622 2.66 13.4622 2.86L8.51219 7.8L13.4622 12.75C13.6622 12.95 13.6622 13.26 13.4622 13.46C13.2622 13.66 12.9522 13.66 12.7522 13.46L7.80219 8.51L2.85219 13.46C2.65219 13.66 2.34219 13.66 2.14219 13.46C1.94219 13.26 1.94219 12.95 2.14219 12.75L7.10219 7.8L2.15219 2.85C1.95219 2.66 1.95219 2.34 2.15219 2.15C2.34219 1.95 2.66219 1.95 2.85219 2.15Z" fill="#0A2071"/>
            </svg>

          </div>
        </div>
        <div class="inner" v-if="loadingAffinity">
          <div class="loaderInnopearl ">
            <div class="loaderInnopearlInner">
              <img :src="require('@/assets/loaderInnopearl.svg')" alt="">
              <span>Please wait a moment...</span>
            </div>

          </div>
        </div>
              <div class="inner" v-else>
        <div class="row realContent">
          <div class="col-12 col-xl-6 interestLevelContainer">
            <div class="barcontainer">
              <div :class="'bar '+result.collab_interest_level">
              </div>
              <div class="jauge" >
                  <label for="low" class="jauge_label low">
                    <input type="radio" id="low" value="low" v-model="result.collab_interest_level"  />
                    <div class="info">
                      <span>{{ $t("Low")}}</span>
                      <small>{{ $t("No Interest")}}</small>
                    </div>
                  </label>
                  <label for="medium"  class="jauge_label medium">
                    <input type="radio" id="medium" value="medium" v-model="result.collab_interest_level" />
                    <div class="info">
                      <span>{{ $t("Medium")}}</span>
                      <small>{{ $t("Consider for later")}}</small>
                    </div>
                  </label>
                  <label for="high"  class="jauge_label high">
                    <input type="radio" id="high" value="high" v-model="result.collab_interest_level" />
                    <div class="info">
                      <span>{{ $t("High")}}</span>
                      <small>{{ $t("Progress now")}}</small>
                    </div>

                  </label>
              </div>
            </div>
            <div class="row nextStep">
              <div class="zone_input">
                <div class="zone_input_header">
                  <span class="zone_input_name"  v-if="result._id == null">{{$t("Next step")}}*</span>
                  <span class="zone_input_name"  v-else>{{$t("Next step")}}*</span>

                </div>

                <div  class="innopearl_input select" >

                  <select  v-model="result.nextstep" placeholder="">
                    <option v-for="(step, n ) in available_next_steps " :key="n" :value="step._id">{{step.name}}</option>
                  </select>
                </div>
              </div>
            </div>

          </div>

          <div class="col-12 col-xl-6 keyActions">

            <div class="disableFeedBack">
              <label for="disableFeedBackCheckbox" class="selectIt" >
                <input class="customizeCheckbox" type="checkbox" v-model="result.keyaction" id="disableFeedBackCheckbox" >
                <span class="custom-checkbox"><img :src="require('@/assets/checkInnoB.svg')" /></span>

                <span class="radio-text">{{ $t("Add key actions")}}</span>
              </label>

              <!-- <label for="withLicense" class="selectIt" >
                <input class="customizeCheckbox" type="checkbox" v-model="internalAssessment.withLicense" value="true" id="withLicense" >
                <span class="boldblue">{{ $t("Assessment by judges with Partner+ licenses")}}</span>
              </label> -->
            </div>
            <div class="keyaction_details" v-if="result.keyaction">
              <div class="zone_input">
                <div class="zone_input_header">
                  <span class="zone_input_name">{{$t("Text")}}</span>
                </div>
                <div >
                  <textarea  class="innopearl_input "  name="name" v-model="result.keyaction_text" rows="3" cols="80" :placeholder="$t('Provide key actions for this innovator')"></textarea>
                </div>
              </div>

              <div class="zone_input">
                <div class="zone_input_header">
                  <span class="zone_input_name">{{$t("Deadline")}}</span>
                </div>
                <div class="innopearl_input " >
                  <input type="date" name="Deadline" v-model="result.keyaction_deadline" />
                </div>
              </div>


              <div class="zone_input">
                <div class="zone_input_header">
                  <span class="zone_input_name">{{$t("Owner")}}</span>
                </div>
                <div class="innopearl_input " >
                  <input type="text" name="Deadline" v-model="result.keyaction_owner" />
                </div>
              </div>

              <div class="col-12 mt50">
                {{$t('You can view, add and track actions in innovator profile')}}
              </div>
            </div>


          </div>
        </div>
        <div class="actions">
            <button type="button" class="cancel" @click="close" name="button">Cancel</button>
            <button type="button" class="confirm" @click="submit" name="button">Confirm</button>

        </div>
      </div>
  </v-card>
  </v-dialog>
  <ToastContainer />
 </div>
</template>


<script>
// import StartupInfoTab from '@/components/StartupInfoTab.vue'
// import StartupHeader from '@/components/StartupHeader.vue'
// import FeedbackDetail from '@/components/FeedbackDetail.vue'
// import InterestRepartitionDetails from '@/components/InterestRepartitionDetailsInside.vue'
// import VoteResultsDetailsInner from '@/components/VoteResultsDetailsInner.vue'
// import AverageVote from '@/components/AverageVote.vue'

import api from '../tools/api';
import { toast } from 'vue-sonner'

export default {
  name : "NextStep",
  data(){
    return {
      shownFeedback:null,
      detailsToogled:null,
      detailsVote: null,
      loadingAffinity :false,
      filtre: "",
      viewMode: 'scores',
      result : {
        _id: null,
        collab_interest_level: 'medium',
        startup :null,
        assessemnt:null,
        nextstep : null,
        keyaction : false,
        keyaction_text : "",
        keyaction_owner:"",
        keyaction_deadline : null
      },
      available_next_steps: []
    }
  },
  components:{

  },
  methods:{
    close(){
        this.$emit('close',false)
    },

    formattedNumber(number) {
          return new Intl.NumberFormat('fr-FR', {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 1
          }).format(number);
    },
    submit(){
      var error = false;
      if(!this.result.nextstep){
        error = true;
        console.log("sfdiousygtf");
        toast.error("Please provide the next step for this innovator");
      }
      console.log(this.result.nextstep);
      if(!error){
        console.log("save");
        this.loadingAffinity = true;
        api.post(process.env.VUE_APP_API_URL+"/restrict/assessment_startup_next_step",
          {result:this.result},
          { headers: {'Content-Type': 'application/json',}}
        ).then( (r) => {
            console.log("criteriaGroups",r.data);
            console.log(r);
            this.loadingAffinity = false;
            toast.success(this.$t("Your entries have been saved! "));
            this.$emit('end',r.data)
          }).catch( (e) => {
            console.log(e);
            this.loadingAffinity = false;
            toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
          });
      }

    }
  },
  watch: {
    dialogVisible: function(){
      console.log("toto",this.vote);
      this.result.startup = this.vote.startup;
      this.result.assessment = this.assessment;
      api.get(process.env.VUE_APP_API_URL+"/restrict/available_next_steps").then( (r) => {
        this.available_next_steps = r.data;
      //first check if there are a result in db
        api.get(process.env.VUE_APP_API_URL+"/restrict/get_assessment_startup_next_step/"+this.result.startup._id.$oid+"/"+this.result.assessment._id.$oid).then( (r) => {
          console.log(r.data);
          if(r.data){
            this.result._id = r.data._id;
            this.result.collab_interest_level = r.data.collab_interest_level;
            this.result.nextstep = r.data.nextstep;
            this.result.keyaction = r.data.keyaction;
            this.result.keyaction_text = r.data.keyaction_text;
            this.result.keyaction_owner = r.data.keyaction_owner;
            if(r.data.keyaction_deadline){
              console.log(r.data.keyaction_deadline.date);
              this.result.keyaction_deadline =  (r.data.keyaction_deadline.date) ? r.data.keyaction_deadline.date.split(' ')[0] : null;
              console.log(this.result.keyaction_deadline);
            }
            else{
              this.result.keyaction_deadline = null;
            }
          }
          else{
            if(this.vote.averageVotePerStartup >= 4){
              //set high interest
              this.result.collab_interest_level = "high"
            }
            else if(this.vote.averageVotePerStartup >= 3){
              //set medium
              this.result.collab_interest_level = "medium"
            }
            else{
              //set low
              this.result.collab_interest_level = 'low';
            }
              this.result._id = null;
            this.result.nextstep = null;
            this.result.keyaction = false;
            this.result.keyaction_text = "";
              this.result.keyaction_owner = "";
            this.result.keyaction_deadline = null;
          }

        }).catch( (e) => {
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")

          console.log(e);toast.error()
        });





      }).catch( (e) => {
        toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")

        console.log(e);toast.error()
      });
    }
  },
  computed: {
    intDialogVisible: {
      get: function () {
        if (this.dialogVisible) {
          // Some dialog initialization code could be placed here
          // because it is called only when this.dialogVisible changes

        }

        return this.dialogVisible
      },
      set: function (value) {
             if (!value) {
                this.$emit('close', value);
             }
      }
    },

  },
  props: {
    dialogVisible: Boolean,
    vote: Object,
    assessment: Object,
  },
}
</script>

<style media="screen" scoped>


.barcontainer{
  background-color: #DDDDDD;
  position: relative;
  width: 30px;
  height: 200px;
  margin-bottom:25px;
  margin-top:30px;
}
.bar{
  background-color: #3783C5;
  position: absolute;
  bottom: 0;
  width: 100%;

  box-sizing: border-box;
  -webkit-transition: all 0.5s linear;
      -moz-transition: all 0.5s linear;
      -o-transition: all 0.5s linear;
      transition: all 0.5s linear;
  transform-origin: bottom;
}
.bar.low{
  height: 10%;
}
.bar.medium{
  height: 50%;
}

.bar.high{
  height: 90%;

}

@keyframes grow{
  from{
    transform: scaleY(0);
  }
}
.mt50{
  margin-top:50px;
}
.jauge_label.low{
  position: absolute;
  bottom :10%;
  transform: translateY(50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}

.jauge_label.medium{
  position: absolute;
  bottom :50%;
  transform: translateY(50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}


.jauge_label.high{
  position: absolute;
  top :10%;
  transform: translateY(-50%);
  right: -210px;
  width: 200px;
  padding-left: 10px;
  display: flex;
  align-items: center;
}

.jauge_label::before{
  content :" ";
  background: #707070;
  width:10px;
  height:1px;
  left: -10px;
  position:absolute;
  top: 50%;
}
.jauge_label input{
  width:22px;
  height:22px;
}

.jauge_label span{
  display:block;
  color: #3783C5;
  font-size: 14px;
  line-height: 22px;
  width:100%;
  font-weight: 500;
  text-transform:uppercase;
}
.jauge_label small{
  color: #575757;
  font-weight: 300;
  font-size:14px;
  line-height: 22px;
}

.and{
  width:100%;
  font-weight: bold;
  font-size:30px;
}

.jauge_label{
  text-align:left !important;
}

.info{
  margin-left:10px;
}


.flex{
  display:flex;
  align-items: center;
    gap: 20px;
}
.barLabel{
  color: #3783C5;
  font-size:18px;
  line-height: 21px;
}
@media screen and (max-width:1200px){
  .flex{
    flex-direction: column;

    align-items: flex-start;
  }
}
.inner{
  padding-left:50px;
  padding-right: 50px;
  padding-bottom: 50px;
  padding-top:0px;
}


.title{
  font-size:26px;
  font-weight:500;

}




.zone_input_name{
  text-align: left;
  font-size: 18px;
  line-height: 21px;
  color: rgba(4, 36, 106, 1);
  font-weight: 600;
}
.zone_input_header{
  display:flex;
  gap: 10px;
  position:relative;
}
.innopearl_input input{
  width:100%;
}
.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
box-sizing: border-box;
margin-top:5px;

padding: 5px;
width:100%;
}
@media screen and (max-width: 990px){
.innopearl_input{
  width:100%;
  margin-left:0;
}
}

textarea.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: 100%;
padding: 5px;
 resize: none;
 height:60px;

}

.innopearl_input.select{
  padding-right:20px;
  width: 300px;
  position:relative;
}
.innopearl_input.select select{
width:100%;
}
.innopearl_input.select::after{
    position:absolute;
  top: calc(50% - 11px);
    right:10px;
    content:  url('@/assets/chevronDown.svg');
}


.selectIt{


display:flex;
align-items: center;
gap: 10px;
}
.selectIt input{
  width:24px;
  height:24px;
  border-radius:50%;
}

.radio-text {
    font-weight: 600;
    color: #04246A; /* Dark color for the text */
    font-size:20px;
}

.keyaction_details{
  margin-top:20px;
}
.zone_input{
  margin-top:20px;
}



.toptophead{
  z-index: 99999;
  background:#FFF;
  padding:20px 50px;
  display:flex;
  align-items: center;
  justify-content: space-between;
}

.toptophead > div{
  flex: 1;
}

.close{
  text-align:right;
    cursor:pointer;
}

.actions{
  width:100%;
  display:flex;
  justify-content: flex-end;
  align-items: center;
  gap:20px;
  margin-top:50px;
}

.actions .cancel{
  border:1px solid #3982C4;
  background:#FFF;
  color:#3982C4;
  padding:7px 35px;
  font-size:16px;
  font-weight: 400;
}
.actions .confirm{
  border:1px solid #3982C4;
  background:#3982C4;
  color:#fff;
  padding:7px 35px;
  font-size:16px;
  font-weight: 400;
}
.nextStep .zone_input{
  margin-top:0px;
}

@media screen and (max-width:1200px){
  .keyActions{
    margin-top:20px !important;
  }
}



  input[type="checkbox"].customizeCheckbox{
    display:none;
  }
  .custom-checkbox img{
        display:none;
        position: absolute;
  top: 3px;
  left: 3px;
  }

  .custom-checkbox {
      width: 25px; /* Circle diameter */
      height: 25px; /* Circle diameter */
      border: 2px solid #5081C1; /* Light gray border for unselected state */
      border-radius: 0%; /* Make it a circle */
      margin-right: 8px; /* Space between the circle and the text */
      transition: border-color 0.3s, background-color 0.3s; /* Smooth transition for color changes */
  }


  input[type="checkbox"].customizeCheckbox:checked + .custom-checkbox {
      border-color: #5081C1; /* Change border color when selected */
      background:#5081C1;
      position:relative;
  }
  input[type="checkbox"].customizeCheckbox:checked + .custom-checkbox > img{
      display:block;
  }
</style>
